const gameLoadingReducers = (state = false, action) => {
  switch (action.type) {
    case "startGameLoading":
      return (state = true);
    case "endGameLoading":
      return (state = false);
    default:
      return state;
  }
};
export default gameLoadingReducers;
